import { OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
var AuthFrameComponent = /** @class */ (function () {
    function AuthFrameComponent(authService) {
        this.authService = authService;
        this.iFrameLoaded = false;
    }
    AuthFrameComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.authSubject = this.authService.getAuthModel();
        this.authSubject.subscribe(function (user) {
            if (!_this.iFrameLoaded) {
                _this.authUser = user;
                var frames_1 = '';
                _this.getFrameLinks().forEach(function (f) {
                    frames_1 = frames_1 + '<iframe id="' + f.name + '" src="' + f.link + '" width="400" height="400" class="hidden"></iframe>';
                });
                document.querySelector("#frame-container").innerHTML = frames_1;
                _this.iFrameLoaded = true;
            }
        });
    };
    AuthFrameComponent.prototype.getFrameLinks = function () {
        if (this.authUser)
            return this.authUser.listIframe;
        return new Array();
    };
    return AuthFrameComponent;
}());
export { AuthFrameComponent };
